import { c as _c } from "react/compiler-runtime";
import { getCancelStudentProgressExportPath } from 'modules/courses/students/api/student-api';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useCancelStudentProgressExport = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching: isCancelling
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = exportId => fetcher(getCancelStudentProgressExportPath(exportId));
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cancelStudentProgressExport = t1;
  let t2;
  if ($[3] !== cancelStudentProgressExport || $[4] !== isCancelling) {
    t2 = {
      cancelStudentProgressExport,
      isCancelling
    };
    $[3] = cancelStudentProgressExport;
    $[4] = isCancelling;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};